import { useMutation } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../../../CommonUtils/urlWithParams';
import { WhatIfDTO, WhatIfTypeDTO } from './useWhatIfGroupsQuery';
import { queryKeys } from '../../pages/AssetBucketingResults/api/queryKeys';
import { queryClient } from '../../../../../config/queryClient';

export interface ApplyWhatIfParams {
  clientId: number;
  fpId: string;
  goalId?: string;
  whatIf: WhatIfDTO;
}

const applyWhatIf = ({
  clientId,
  fpId,
  goalId,
  whatIf,
}: ApplyWhatIfParams): Promise<WhatIfTypeDTO> =>
  authFetch(
    urlWithParams(`/Consumer/WhatIf${whatIf.WhatIfTypeName}/ApplyToPlan`, {
      clientId,
      fpId,
      goalId,
    }),
    {
      method: 'POST',
      ...httpBodyOptions(
        {
          WhatIf: whatIf,
        },
        true,
      ),
    },
  );

export const useApplyWhatIfMutation = () => {
  return useMutation(applyWhatIf, {
    async onSuccess(_, { clientId, fpId }) {
      await queryClient.invalidateQueries(queryKeys.AssetBucketing(clientId, fpId));
    },
  });
};
